import React from "react";
import HireToBuild from "./HireToBuild";

const Outsourcing = () => {
  return <HireToBuild />;
};

export default Outsourcing;
